import React from 'react'
import { IonContent, IonIcon, IonText } from '@ionic/react'
import './AllErrorsCleared.component.css'
import { checkmarkCircleOutline } from 'ionicons/icons'
import useAreAllErrorsCleared from '../hooks/useAreAllErrorsCleared.hook'
import { getCompleteChartSelector } from '../selectors'
import { useSelector } from 'react-redux'
import { CompleteChartConstants } from '../store/completeChart.constants'
import useAreAllWarningsCleared from '../hooks/useAreAllWarningsCleared.hook'
import useCheckToDisableBasedOnCustomStateRules from '../hooks/useCheckToDisableBasedOnCustomStateRules.hook'
import { useTranslation } from 'react-i18next'

const AllErrorsCleared: React.FC = () => {
  const allErrorsCleared = useAreAllErrorsCleared()
  const allWarningsCleared = useAreAllWarningsCleared()
  const { selectedOption } = useSelector(getCompleteChartSelector)
  const disableBasedOnCustomStateRules = useCheckToDisableBasedOnCustomStateRules()
  const { t } = useTranslation()

  const renderErrorOrWarning = (renders: string) => {
    return (
      <IonContent>
        <div className='flex-column-center'>
          <IonIcon size='medium' icon={checkmarkCircleOutline} className='all-errors-cleared-icon' />
          <section className='text-align-center'>
            <IonText className='all-errors-cleared'>
              {renders === CompleteChartConstants.SET_ERRORS_TAB && (
                <>
                  {disableBasedOnCustomStateRules ? (
                    <>
                      {t('completeChart.requiresCompletionInWeb1')} <br />
                      {t('completeChart.requiresCompletionInWeb2')}{' '}
                    </>
                  ) : (
                    <>
                      {t('completeChart.clearedAllErrors1')} <br />
                      {t('completeChart.clearedAllErrors2')}
                    </>
                  )}
                </>
              )}
              {renders === CompleteChartConstants.SET_WARNINGS_TAB && <>This chart has cleared all warnings</>}
            </IonText>
          </section>
        </div>
      </IonContent>
    )
  }

  return (
    <>
      {allErrorsCleared && selectedOption === CompleteChartConstants.SET_ERRORS_TAB
        ? renderErrorOrWarning(selectedOption)
        : null}
      {allWarningsCleared && selectedOption === CompleteChartConstants.SET_WARNINGS_TAB
        ? renderErrorOrWarning(selectedOption)
        : null}
    </>
  )
}

export default AllErrorsCleared
